import request from '@/utils/request'

// 在线ca初始化
export const caInit = (data) => {
    return request.get('/api/ca/auth/init')
}
//单文件单章接口
export const batchSign = (data) => {
    return request.post('/api/ca/file/sign', data)
}
//获取证书列表
export const getCertList = () => {
    return request.get('/api/ca/seal/list')
}





//签章绑定用户接口 POST 
export const bindPersonSeal = (data) => {
    return request.post('/api/ca/add/person', data)
}
//签章绑定用户授权接口
export const getPersonAuth = (type) => {
    return request.get('/api/ca/add/person/auth?type='+type)
}
// 获取签章绑定用户列表
export const getPersonSealList = (data) => {
    return request.post('/api/ca/add/person/list',data)
}
// 获取授权需求信息 (1: 经办人授权, 2: 超级管理员授权) true 需要授权  .  调用 getPersonAuth 并且展示 输入授权码  输入完以后  bindPersonSeal
export const getNeedAuth = (type) => {
    return request.get('/api/ca/need/auth?type='+type)
}
//  修改状态
export const editPersonStatus = (data) => {
    return request.post('/api/ca/edit/person/status', data)
}